import { useQuery } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';

export function useFindPJOptions({ enabled = false, token = '', legalCode }) {
  const query = useQuery({
    queryKey: ['find-simulation-options-pj', token, legalCode],
    enabled: enabled && !!token && !!legalCode,
    queryFn: async () => {
      const data = await handleFetchResponse(
        fetch(getApiUrl(`energia-solar/v2/simulation/options-pj/${legalCode}`), {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
      );
      return data;
    },
    retry: false,
    initialData: {
      legalRelationships: [],
    },
  });

  return query;
}
